require('./bootstrap');
window.Vue = require('vue');

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('contact-map', require('./components/ContactMap.vue').default);
Vue.component('hamburger', require('./components/Hamburger.vue').default);
Vue.component('clients', require('./components/Clients.vue').default);

var VueTyperPlugin = require('vue-typer').default
Vue.use(VueTyperPlugin);

const app = new Vue({
    el: '#app',
    data() {
       return {
            showMenu: false,
        }
    },
    mounted() {
        console.log('Coding Agency created');
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
            console.log('toggleMenu: ' + this.showMenu);
            const body = document.querySelector('body')
            body.classList.toggle('modal-active')
        },
        goToUrl(url) {
            return window.location = url;
        },
    }
});


// https://www.tailwindtoolbox.com/components/fullscreen-modal
var openmodal = document.querySelectorAll('.modal-open')
for (var i = 0; i < openmodal.length; i++) {
    openmodal[i].addEventListener('click', function(event) {
        event.preventDefault()
        toggleModal()
    })
}
// const overlay = document.querySelector('.modal-overlay')
// overlay.addEventListener('click', toggleModal)
var closemodal = document.querySelectorAll('.modal-close')
for (var i = 0; i < closemodal.length; i++) {
    closemodal[i].addEventListener('click', toggleModal)
}
document.onkeydown = function(evt) {
    evt = evt || window.event
    var isEscape = false
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc")
    } else {
        isEscape = (evt.keyCode === 27)
    }
    if (isEscape && document.body.classList.contains('modal-active')) {
        toggleModal()
    }
};

function toggleModal() {
    const body = document.querySelector('body')
    const modal = document.querySelector('.modal-menu')
    modal.classList.toggle('opacity-0');
    modal.classList.toggle('pointer-events-none')
    body.classList.toggle('modal-active')
}
